import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */
import html from "~/util/html.js";

/** @import { TriggerProps } from "~/component/Tooltip.js"; */
import Tooltip from "~/component/Tooltip.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./DisabledTooltip.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./DisabledTooltip.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @param {object} props
 * @param {ComponentChildren} [props.tooltip]
 * @param {ComponentChildren} [props.children]
 */
export default function DisabledTooltip({
  tooltip,
  children
}) {
  return __h(Tooltip, {
    contents: tooltip,
    disabled: !tooltip
  }, (/** @type {TriggerProps} */trigger) => __h("span", {
    "class": css.trigger,
    ...trigger
  }, children));
}